

































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { FieldChildrenProp } from '@/services/hexabase/types';
import Button from '@/components/common/elements/Button.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Icon from '@/components/common/elements/Icon.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';

import { underButtonArray } from '@/constants/components/searchPanel';

@Component({
  components: {
    Button,
    SingleText,
    Icon,
    AutoCreateForm
  }
})
export default class SearchPanelComponent extends Vue {
  // 下部ボタン
  private underButtonArray = underButtonArray;
  // 画面開閉状態
  private switchButtonValue?: boolean = true;
  // 開閉状態アイコン
  private switchButtonIcon?: string = 'mdi-chevron-down';

  @Prop({ default: () => [] })
  private fieldData?: Array<FieldChildrenProp>;
  @Prop()
  private fieldCols: any;

  @Prop({ default: {} })
  private fieldTypes?: { [k: string]: string };
  private searchConditions: Array<{ [key: string]: string | string[] }> = [];

  private onGotoRegistration(): void {
    this.$router.push('/construction/registration');
  }

  /**
   * パネル開閉ボタン
   * 確認用 仕様不明の為仮実装
   * @module showDetailInformation
   * @param {boolean} flag - パネル開閉状態フラグ
   * @return {void} - コンソールに出力
   */
  private showDetailInformation() {
    if (this.switchButtonValue === true) {
      this.switchButtonValue = false;
      this.switchButtonIcon = 'mdi-chevron-down';
    } else {
      this.switchButtonValue = true;
      this.switchButtonIcon = 'mdi-chevron-up';
    }
  }

  /**
   * 子コンポーネントからEmitされる値を取得
   * 検索用Paramを作成し「searchConditions」に格納
   * @module catchInput
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  private catchInput(response: any) {
    if (response.value === undefined) return;
    const searchVal = this.createSearchConditionList(
      response,
      this.searchConditions,
      this.fieldTypes
    );
    const findIndex = this.searchConditions.findIndex(recode => recode.id === searchVal.id);
    if (findIndex === -1) {
      this.searchConditions.push(searchVal);
    } else {
      this.searchConditions[findIndex] = { ...searchVal };
      if (!this.issearchValue(searchVal)) {
        this.searchConditions.splice(findIndex);
      }
    }
  }

  private issearchValue(searchVal: { [key: string]: string | string[] }) {
    return searchVal.search_value[0].length === 0 ? false : true;
  }

  public createSearchConditionList(
    input: { [k: string]: string },
    searchConditions: Array<{ [key: string]: string | string[] }>,
    typeList?: { [k: string]: string }
  ) {
    const condition: { [key: string]: any } = {};
    const type = typeList![input.name];
    switch (type) {
      case 'datetime': {
        condition['id'] = input.name;
        const range = input.range;
        const currentData = searchConditions.find(v => v.id === input.name);
        if (range && currentData === undefined) {
          if (range === 'from') {
            condition['search_value'] = [input.value, null];
          } else if (range === 'to') {
            condition['search_value'] = [null, input.value];
          }
        } else {
          condition['search_value'] = currentData!.search_value;
          const index = range === 'from' ? 0 : 1;
          condition['search_value'][index] = input.value;
        }
        break;
      }
      case 'number': {
        condition['id'] = input.name;
        condition['search_value'] = [String(input.value), String(input.value)];
        break;
      }
      default: {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        break;
      }
    }
    return condition;
  }

  private buttomAction(type: any): void {
    if (type === 'search') {
      this.execsearch();
    } else {
      this.resetForm();
    }
  }

  @Emit('execsearch')
  private execsearch() {
    return this.searchConditions;
  }

  @Emit('resetForm')
  private resetForm() {
    // refを使用しformをリセット
    const form: any = this.$refs.form;
    form.reset();
    // 内部プロパティの検索条件をクリア
    this.searchConditions.splice(0);
    return this.searchConditions;
  }
}
